import { formatInstantToPtBR } from '@/shared/lib';
import type { CreatedFolderResponse } from '../api/directories.api';
import type { DirectoryTreeNode } from './types';

export function mapCreatedFolderToTreeNode(
  folder: CreatedFolderResponse,
  creatorDisplayName: string
): DirectoryTreeNode {
  const nodeId = `folder-${folder.id}`;

  return {
    id: nodeId,
    name: folder.name,
    kind: 'folder',
    moduleId: folder.moduleId,
    details: {
      title: folder.name,
      createdAt: folder.createdAt,
      createdAtLabel: formatInstantToPtBR(folder.createdAt),
      createdBy: creatorDisplayName,
      savedInDirectoryBy: creatorDisplayName,
    },
    children: [],
  };
}
